import { render, staticRenderFns } from "./TableAnimals.vue?vue&type=template&id=6e3ca173&"
import script from "./TableAnimals.vue?vue&type=script&lang=ts&"
export * from "./TableAnimals.vue?vue&type=script&lang=ts&"
import style0 from "./TableAnimals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports